/**
 * @generated SignedSource<<234951aaf82738869784330b005a39a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesTableRateEditorForm_packageDate$data = {
  readonly end: string;
  readonly flight: {
    readonly priceLive: number;
  } | null;
  readonly id: string;
  readonly start: string;
  readonly " $fragmentType": "RoomRatesTableRateEditorForm_packageDate";
};
export type RoomRatesTableRateEditorForm_packageDate$key = {
  readonly " $data"?: RoomRatesTableRateEditorForm_packageDate$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateEditorForm_packageDate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesTableRateEditorForm_packageDate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "start",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "end",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Flight",
      "kind": "LinkedField",
      "name": "flight",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "priceLive",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PackageDate",
  "abstractKey": null
};

(node as any).hash = "b0a6c6744f4b5f811a5099435ea6738c";

export default node;
